export interface SliderModelValue {
  min: number;
  max: number;
}

export enum HandleKind {
  Lower = 'lower',
  Upper = 'upper',
}
